<div class="obg-m-argentine-session-limit-header">
	<img obgImageContent="general.session-limit-time" />
	<div>
		<h1>{{ 'multi-session-limit.title' | translate }}</h1>
		<p>{{ 'multi-session-limit.description' | translate }}</p>
	</div>
</div>

<div class="obg-m-argentine-session-limit-queued-notification" *ngIf="upcomingSessionLimit">
	<span class="notification-icon ico-exclamation"></span>
	<label
		[innerHTML]="'multi-session-limit.upcoming-limit.' + (upcomingSessionLimit.limitPeriod | lowercase) | translate: {
				queuedLimit: upcomingSessionLimit.limitValue,
				activeFrom: upcomingSessionLimit.activeFrom | date: 'dd MMMM yyyy'
			}"
		test-id="upcoming-limit"
	>
	</label>
</div>

<mat-card class="obg-m-argentine-session-limit-container">
	<h2>{{ 'multi-session-limit.title' | translate }}</h2>
	<div>
		<span>{{ 'multi-session-limit.current-limit' | translate }}</span>
		<span
			class="obg-m-argentine-session-limit-amount"
			*ngIf="currentSessionLimit; else noLimit"
			[innerHTML]="'multi-session-limit.current-limit.' + (currentSessionLimit.limitPeriod | lowercase) | translate: {
				limit: currentSessionLimit.limitValue
			}"
			test-id="current-limit-amount"
		>
		</span>

		<ng-template #noLimit>
			<span>{{ "general.not-set" | translate }}</span>
		</ng-template>
	</div>
	<div class="btn-container" *ngIf="!isSessionLimitEdited">
		<button mat-flat-button color="primary" (click)="editSessionLimit()" [disabled]="isSettingBusy">
			<mat-spinner *ngIf="isSettingBusy; else showContent" diameter="20"></mat-spinner>
			<ng-template #showContent>{{ 'multi-session-limit.change-session-limit' | translate }}</ng-template>
		</button>
	</div>
</mat-card>
<mat-card class="obg-m-argentine-session-limit-edit" *ngIf="isSessionLimitEdited">
	<form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submitSessionLimit()">
		<h2>{{ 'responsible-gaming.enter-session-time-limits' | translate }}:</h2>

		<mat-radio-group formControlName="sessionLimitPeriod">
			<mat-radio-button [value]="sessionLimitPeriodControls.Daily" [checked]="true" color="primary"
				>{{ 'multi-session-limit.daily' | translate }}</mat-radio-button
			>
			<mat-radio-button [value]="sessionLimitPeriodControls.Weekly" color="primary"
				>{{ 'multi-session-limit.weekly' | translate }}</mat-radio-button
			>
			<mat-radio-button [value]="sessionLimitPeriodControls.Monthly" color="primary"
				>{{ 'multi-session-limit.monthly' | translate }}</mat-radio-button
			>
		</mat-radio-group>

		<mat-form-field floatLabel="always">
			<mat-label>{{ 'multi-session-limit.label' | translate }}</mat-label>
			<input
				matInput
				type="tel"
				[placeholder]="placeholder"
				formControlName="sessionLimitAmount"
				obgNumericNotZero
				required
			/>
		</mat-form-field>

		<obg-common-validation-renderer
			[input]="formGroup.controls.sessionLimitAmount"
			translationPrefix="multi-session-limit"
		>
		</obg-common-validation-renderer>

		<div class="btn-container">
			<button mat-flat-button color="primary" type="submit" [disabled]="!formGroup.valid">
				{{ 'multi-session-limit.set-session-time-limits' | translate }}
			</button>
		</div>
	</form>
</mat-card>

<div class="caption" [innerHtml]="'multi-session-limit.information'| translate"></div>
